var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8411 37.5833C27.8411 39.0417 28.112 40.4375 28.5703 41.75H11.1745C10.0694 41.75 9.0096 41.311 8.2282 40.5296C7.4468 39.7482 7.00781 38.6884 7.00781 37.5833V8.41667C7.00781 6.125 8.88281 4.25 11.1745 4.25H40.3411C41.4462 4.25 42.506 4.68899 43.2874 5.47039C44.0688 6.25179 44.5078 7.3116 44.5078 8.41667V25.8125C43.1953 25.3542 41.7995 25.0833 40.3411 25.0833V8.41667H11.1745V37.5833H27.8411ZM29.8411 23.6042L24.112 30.9792L20.0286 26.0625L14.2995 33.4167H28.5703C29.4036 31.0833 30.9036 29.0625 32.8411 27.6042L29.8411 23.6042ZM42.4245 35.5V29.25H38.2578V35.5H32.0078V39.6667H38.2578V45.9167H42.4245V39.6667H48.6745V35.5H42.4245Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.e7341d30b7d4eac0e554f87e29ddefb4.svg";
export { ForwardRef as ReactComponent };